export default __webpack_public_path__ + "static/media/sliced-orange.9f93be57.png";